export default __webpack_public_path__ + "static/media/Truly_Logo_Light.58f569d7.png";